import type { GetImpulseFormOutput, GetImpulseFormOutputVerbose } from "~/tools/impulse-form";

import type { DashboardWidgetLegend } from "../../../../common/dashboard-spec/chart-schemas";
import { WidgetLegend } from "../../../widget-form/legend/form-state";
import type { WidgetFormSync } from "../../../widget-form/sync";
import type { FormProcessor } from "../../_form-processor";

type Spec = DashboardWidgetLegend;
type FormState = WidgetLegend;

const DEFAULT = WidgetLegend.default;

function specToInput(legend: Spec) {
	return {
		enabled: legend?.show ?? DEFAULT.enabled,
		position: legend?.position ?? DEFAULT.element.position,
		mode: legend?.mode ?? DEFAULT.element.mode.active,
		table: legend?.values,
	} satisfies WidgetFormSync["legend"];
}

function outputToSpec(legend: GetImpulseFormOutput<FormState>): Spec {
	return {
		show: legend != null,
		position: legend?.position,
		mode: legend?.mode.kind,
		values: legend?.mode.kind === "table" ? legend.mode.value.toArray() : undefined,
	};
}

function verboseOutputToSpec({ enabled, element }: GetImpulseFormOutputVerbose<FormState>): Spec {
	return {
		show: enabled ?? undefined,
		position: element.position ?? undefined,
		mode: element.mode.active ?? undefined,
		values: element.mode.active === "table" ? element.mode.branches.table?.toArray() : undefined,
	};
}

type Input = ReturnType<typeof specToInput>;

function init(initial?: Input): FormState {
	return WidgetLegend.init({
		enabled: initial?.enabled,
		element: {
			position: initial?.position,
			mode: {
				active: initial?.mode,
				branches: {
					table: initial?.table,
				},
			},
		},
	});
}

const FormState = {
	init,
	specToInput,
	outputToSpec,
	verboseOutputToSpec,
} satisfies FormProcessor<Spec, FormState, Input>;

export { FormState };
